import "./style.scss";

import { useIsMobile } from "hooks/useIsMobile";

interface QuickActionProps {
    /**
     * The text to display in the quick action
     */
    text: string;
    /**
     * The icon to display in the quick action
     */
    icon: JSX.Element;
    /**
     * The called function when the quick action is clicked
     */
    onClick: () => void;
}

/**
 * This component is used to display a quick action with an icon and a text
 * Better used in a flex div, with a gap
 * @param text The text to display in the quick action
 * @param icon The icon to display in the quick action
 * @param onClick The called function when the quick action is clicked
 */
const QuickAction = (props: QuickActionProps) => {
    const { isPhone } = useIsMobile();
    const { text, icon, onClick } = props;
    const normalizedText = text.replace("\\n", "<br />").replace("\n", "<br />");

    return (
        <div className="quick-action" onClick={onClick}>
            <div className="quick-action-icon">{icon}</div>
            <div className="quick-action-text">
                {isPhone && <span>{text}</span>}
                {!isPhone && <span dangerouslySetInnerHTML={{ __html: normalizedText }}></span>}
            </div>
        </div>
    );
};

export default QuickAction;
